import { UserRole } from 'shared/types/userRole';

export const isVisibleNoAccess = (role: UserRole): boolean => {
  return role === UserRole.visible_no_access;
};
